import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const StatusToggleSection = ({ isActive, onChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Power" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">Company Status</h2>
          <p className="text-sm text-text-secondary">Control company activation</p>
        </div>
      </div>
      <div className="space-y-4">
        <Checkbox
          label="Active Company"
          description="Enable this company's visualizer and client dashboard access"
          checked={isActive}
          onChange={(e) => onChange(e?.target?.checked)}
        />

        <div className={`p-4 rounded-lg border-2 ${isActive ? 'bg-success/5 border-success' : 'bg-muted border-border'}`}>
          <div className="flex items-start gap-3">
            <Icon 
              name={isActive ? 'CheckCircle' : 'XCircle'} 
              size={20} 
              className={isActive ? 'text-success' : 'text-text-secondary'}
            />
            <div>
              <p className="text-sm font-medium text-text-primary mb-1">
                {isActive ? 'Company is Active' : 'Company is Inactive'}
              </p>
              <p className="text-sm text-text-secondary">
                {isActive 
                  ? 'Customers can access the visualizer and all features are enabled. The company appears in active listings.' :'Visualizer access is disabled. Customers cannot use this company\'s tools. The company is hidden from active listings.'}
              </p>
            </div>
          </div>
        </div>

        {!isActive && (
          <div className="p-4 bg-warning/10 border border-warning rounded-lg">
            <div className="flex items-start gap-3">
              <Icon name="AlertTriangle" size={16} className="text-warning mt-0.5" />
              <div className="text-sm text-text-secondary">
                <p className="font-medium text-text-primary mb-1">Deactivation Impact</p>
                <p>When inactive, all customer-facing URLs will show an error message. Existing reference codes will remain stored but inaccessible until reactivation.</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatusToggleSection;